import PropTypes from 'propTypes'
import { connect } from 'react-redux'

import { getProductPlan } from '../../selectors/productPlan'
import { companyDetails as companyDetailsSelector } from '../../selectors/company'

const CompanySubscription = ({ children, productPlan, companyDetails }) => children({ companyDetails, productPlan })

const mapStateToProps = state => ({
  companyDetails: companyDetailsSelector(state),
  productPlan: getProductPlan(state),
})

CompanySubscription.propTypes = {
  children: PropTypes.func,
}

export default connect(mapStateToProps)(CompanySubscription)
